import Divider from '@mui/material/Divider';

function NoData() {
  return (
    <Divider sx={{ color: '#cccccc', fontStyle: 'italic' }}>No data</Divider>
  );
}

export default NoData;
